/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography,
  Card,
  List,
  Avatar,
  Image,
  Spin,
  Empty,
} from "antd";
import dayjs from "dayjs";

// Locales
import "dayjs/locale/th";
import { APIEndpointWeb, webapi } from "@client/web";
import { useCookies } from "react-cookie";
import { Redirect } from "react-router-dom";

import {
  CK_SHARED_TOKEN,
  CK_ACCESS_TOKEN,
  CK_ACCESS_DATA_ROLE,
} from "@constant/constant";

const { Text } = Typography;

export interface IConsentTopic {
  hospital_name: string;
  insurance_agent: string;
  insurance_name: string;
  received_date: string;
  logo: string;
}

const RequestedHistory: React.FC = (): JSX.Element => {
  const [goToPath, setGoToPath] = useState("");
  const [resInsurance, setResInsurance] = useState<[]>();
  const [loading, setLoading] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
  ]);

  useEffect(() => {
    getapi();
  }, []);

  const getapi = async () => {
    setLoading(true);
    try {
      const { data } = await webapi.get(`${APIEndpointWeb.GetCheckHistory}`, {
        withCredentials: true,
        // headers: { Authorization: `Bearer ${cookies.shared_token}` },
      });
      setResInsurance(data.result ? data.result : []);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <div>
      <Row className="pl-3 pr-3">

      </Row>
      {/* end */}

      <Spin tip="กำลังโหลด..." spinning={loading}>
        <div
          className=""
        //style={{ backgroundColor: "red" }}
        >
          <Row
            className="p-2 mr-5 ml-5  mt-5"
            style={{
              backgroundColor: "#fff",
              boxShadow: " 2px 2px 10px rgba(0, 0, 0, 0.25)",
              borderRadius: "20px",
              height: 575,
            }}
          >

            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              xxl={24}
              className="pr-3 pl-3 pt-3"
            //style={{ backgroundColor: "blue" }}
            >
              <div
                className="pt-2 pr-4 pl-4 pb-2 large-2"
                style={{
                  //overflowY: "scroll",
                  height: "90%",
                }}
              >
                {goToPath ? <Redirect to={goToPath} /> : null}
                {resInsurance && resInsurance.length > 0 ? (
                  <List
                    grid={{ gutter: 16, column: 2 }}
                    style={{
                      width: "100%",
                      //height: "100%",
                      // maxHeight: 500,
                      overflowX: "hidden",
                    }}
                    itemLayout="vertical"
                    dataSource={resInsurance}
                    renderItem={(item: IConsentTopic, index: number) => (
                      <List.Item>
                        <Card
                          className="ml-2 mr-2"
                          bordered={false}
                          style={{
                            background: "#fff",
                            boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.25)",
                            //boxShadow: " 2px 2px 10px rgba(0, 0, 0, 0.25)",
                            borderRadius: "20px",
                            marginTop: '10px'
                          }}
                        >
                          <Row>
                            <Col
                              xs={19}
                              sm={19}
                              md={19}
                              lg={19}
                              xl={19}
                              xxl={19}
                              style={{ marginBottom: "-2rem" }}
                            >
                              <List.Item.Meta
                                title={
                                  <div className="font-title">
                                    <Text strong>{item.insurance_name}</Text>{" "}
                                    <br />
                                    <Text strong className="size-16">
                                      วันที่ได้รับประวัติการรักษา
                                    </Text>{" "}
                                    <Text className="size-16">
                                      {dayjs(item.received_date)
                                        .subtract(7, 'hour')
                                        .add(543, "year")
                                        .format("DD/MM/YYYY")}
                                    </Text>
                                    <br />
                                    <Text strong className="size-16">
                                      ตัวแทนขายประกัน
                                    </Text>{" "}
                                    <Text className="size-16">
                                      {item.insurance_agent}
                                    </Text>
                                    <br />
                                    <Text strong className="size-16">
                                      {item.hospital_name}
                                    </Text>{" "}
                                  </div>
                                }
                              />
                            </Col>
                            <Col
                              className="mt-1"
                              xs={5}
                              sm={5}
                              md={5}
                              lg={5}
                              xl={5}
                              xxl={5}
                            >
                              <List.Item.Meta
                                avatar={
                                  <Avatar
                                    key={index}
                                    size={80}
                                    //style={{ backgroundColor: "#E5E5E5" }}
                                    src={
                                      <Image
                                        preview={false}
                                        src={`data:image/jpeg;base64,${item.logo}`}
                                        style={{
                                          // width: "60px",
                                          marginTop: "5px",
                                        }}
                                      />
                                    }
                                  />
                                }
                              />
                            </Col>
                          </Row>
                        </Card>
                      </List.Item>
                    )}
                  />
                ) : (
                  <div style={{ justifyItems: 'center', marginTop: '20%' }}><Empty description={"ไม่มีข้อมูล1111"} /></div>
                )}
              </div>
            </Col>

          </Row>

        </div>
      </Spin>
    </div>
  );
};
export default RequestedHistory;
